"use client"

import { useState } from "react"
import { useAuth } from "../contexts/AuthContext"
import { useLanguage } from "../contexts/LanguageContext"
import { AdminDashboard } from "./AdminDashboard"
import { TeacherDashboard } from "./TeacherDashboard"
import { StudentDashboard } from "./StudentDashboard"
import { ChangePasswordModal } from "./ChangePasswordModal"
import { LanguageSelector } from "./LanguageSelector"
import { Icons } from "./Icons"

export function AppLayout() {
  const { user, logout } = useAuth()
  const { t } = useLanguage()
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false)

  if (!user) return null

  const getRoleIcon = () => {
    return <Icons.Logo  className="w-8 h-8"/>;
    // switch (user.role) {
    //   case "admin":
    //     return <Icons.Admin className="w-8 h-8 text-red-600" />
    //   case "teacher":
    //     return <Icons.Teacher className="w-8 h-8 text-green-600" />
    //   case "student":
    //     return <Icons.Student className="w-8 h-8 text-blue-600" />
    //   default:
    //     return <Icons.User className="w-8 h-8 text-gray-600" />
    // }
  }

  const getRoleName = () => {
    return t(`role.${user.role}`)
  }

  const renderDashboard = () => {
    switch (user.role) {
      case "admin":
        return <AdminDashboard />
      case "teacher":
        return <TeacherDashboard />
      case "student":
        return <StudentDashboard />
      default:
        return <div>Unknown user role</div>
    }
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#f8fafc" }}>
      {/* Навигационная панель */}
      <nav className="navbar">
        <div className="container">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-4">
              <div>{getRoleIcon()}</div>
              <div>
                <h1 className="text-lg font-semibold">{t("system.title")}</h1>
                <p className="text-sm text-gray-600">{getRoleName()}</p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="text-right">
                <p className="text-sm font-medium">{user.full_name}</p>
                <p className="text-xs text-gray-600">{user.email}</p>
              </div>

              <LanguageSelector />

              <button
                className="btn btn-outline btn-sm flex items-center space-x-2"
                onClick={() => setIsPasswordModalOpen(true)}
              >
                <Icons.Settings className="w-4 h-4" />
                <span>{t("common.settings")}</span>
              </button>

              <button className="btn btn-outline btn-sm flex items-center space-x-2" onClick={logout}>
                <Icons.Logout className="w-4 h-4" />
                <span>{t("auth.logout")}</span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Основной контент */}
      <main className="container py-6">{renderDashboard()}</main>

      {/* Модальное окно смены пароля */}
      <ChangePasswordModal
        isOpen={isPasswordModalOpen || (user.is_temp_password ?? false)}
        onClose={() => setIsPasswordModalOpen(false)}
        isRequired={user.is_temp_password ?? false}
      />
    </div>
  )
}
